import {Shape1} from "../../Shapes/Section6/Shape1";
import {Shape2} from "../../Shapes/Section6/Shape2";
import {Shape3} from "../../Shapes/Section6/Shape3";
import {Shape4} from "../../Shapes/Section6/Shape4";
import {Shape5} from "../../Shapes/Section6/Shape5";
import {Shape6} from "../../Shapes/Section6/Shape6";
import {Shape7} from "../../Shapes/Section6/Shape7";
import {Shape8} from "../../Shapes/Section6/Shape8";
import {StitchPicturesButton} from "../../common/StitchPicturesButton/StitchPicturesButton";
import {logFirebaseEvent} from "../../../helpers/firebase_helper";

export interface IStitchFeatureSection6Props {
  backgroundColor: string;
  shapeColors: Record<
    | "shape1"
    | "shape2"
    | "shape3"
    | "shape4"
    | "shape5"
    | "shape6"
    | "shape7"
    | "shape8",
    string
  >;
}

export const StitchFeatureSection6 = ({
  backgroundColor,
  shapeColors,
}: IStitchFeatureSection6Props) => {
  return (
    <div
      style={{ backgroundColor }}
      className="relative py-24 flex flex-col items-center justify-center gap-8"
    >
      <h2 className="text-6xl text-center">Combine Photos</h2>
      {/* <StitchPicturesButton text="Select Photos" /> */}
      <StitchPicturesButton
        text="Select Photos"
        onFileSelect={() => {
          logFirebaseEvent("cus_select_photos", {
            location: "web_stitch",
          });
        }}
      />

      <div className="hidden lg:block absolute top-8 left-0">
        <Shape1 fill={shapeColors.shape1} />
      </div>

      <div className="hidden lg:block absolute top-0 left-16">
        <Shape2 fill={shapeColors.shape2} />
      </div>

      <div className="hidden lg:block absolute top-0 right-1/2">
        <Shape3 fill={shapeColors.shape3} />
      </div>

      <div className="hidden lg:block absolute top-0 right-16">
        <Shape4 fill={shapeColors.shape4} />
      </div>

      <div className="hidden lg:block absolute bottom-0 right-0">
        <Shape5 fill={shapeColors.shape5} />
      </div>

      <div className="hidden lg:block absolute bottom-0 right-1/4">
        <Shape6 fill={shapeColors.shape6} />
      </div>

      <div className="hidden lg:block absolute top-1/2 right-1/2 -translate-x-32 translate-y-4">
        <Shape7 fill={shapeColors.shape7} />
      </div>

      <div className="hidden lg:block absolute bottom-0 left-4">
        <Shape8 fill={shapeColors.shape8} />
      </div>
    </div>
  );
};
